import { render } from "./FancyCheckbox.vue?vue&type=template&id=e20b416c&scoped=true"
import script from "./FancyCheckbox.vue?vue&type=script&lang=js"
export * from "./FancyCheckbox.vue?vue&type=script&lang=js"

import "./FancyCheckbox.vue?vue&type=style&index=0&id=e20b416c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20b416c"]])

export default __exports__